import { render, staticRenderFns } from "./Step_confirm.vue?vue&type=template&id=65f3337b&scoped=true"
import script from "./Step_confirm.vue?vue&type=script&lang=js"
export * from "./Step_confirm.vue?vue&type=script&lang=js"
import style0 from "./Step_confirm.vue?vue&type=style&index=0&id=65f3337b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f3337b",
  null
  
)

export default component.exports